import Static from "../../canvases/static";
import { useCallback, useEffect } from "react";
import { selectActiveBoard } from "../../../../../template-editor/store/templates/selectors";
import { useSelector } from "react-redux";

interface IProps {
  manager: Static;
  isManagerInit: boolean;
}

const errorPercent = 10

function useOnLoadedTV(props: IProps) {
  const { manager, isManagerInit } = props
  const activeBoard = useSelector(selectActiveBoard)
  
  useEffect(() => {
    if (!manager) return
    if (!isManagerInit) return
    const body = document.getElementsByTagName('body')[ 0 ]
    const canvasBoards = document.getElementById('boards');
    const canvasEvents = document.getElementById('events');
    
    if (activeBoard?.type !== 'tv') {
      body?.setAttribute('style', 'background: unset; overflow: hidden')
      manager?.setDimensions(manager.resolution.value)
      manager.normalizedViewport()
      
      const style = `width: ${manager.resolution.value.width}; height: ${manager.resolution.value.height};`
      canvasEvents?.setAttribute('style', style);
      canvasBoards?.setAttribute('style', style);
      
      manager.normalizedViewport()
      return
    }
    
    function canvasResize() {
      if (!manager) return
      
      const w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[ 0 ],
        x = w.innerWidth || e.clientWidth || g.clientWidth,
        y = w.innerHeight || e.clientHeight || g.clientHeight;
      
      const cv = document.getElementById('boards');
      const canvasEvents = document.getElementById('events');
      if (!cv) return
      
      const sizeX = manager.resolution.value.width ?? 1920;
      const sizeY = manager.resolution.value.height ?? 1080;
      
      let cx, cy;                  //The size of the canvas-Element
      if (sizeX / sizeY <= x / y) {
        const maxFactor = Math.max(sizeX / sizeY, sizeY / sizeX);
        cy = y
        cx = y * maxFactor
      } else {
        const minFactor = Math.min(sizeX / sizeY, sizeY / sizeX);
        cx = x
        cy = cx * minFactor
      }
      
      cv.setAttribute("style", "width:" + cx + "px;height:" + cy + "px;");    //canvas: 16:9, as big as possible, horizintally centere
      canvasEvents?.setAttribute('style', `display: none`);
    }
    
    canvasResize()
    window.addEventListener("resize", canvasResize);
    
    return () => {
      window.removeEventListener("resize", canvasResize);
    }
  }, [activeBoard?.type, isManagerInit, manager]);
  
  const onLoaded = useCallback(() => {
    if (!manager) return
    const body = document.getElementsByTagName('body')[ 0 ]
    
    const allObjects = manager?.canvas?.getObjects()
    const windowSize = manager.resolution.value.width * manager.resolution.value.height
    
    const isWithinErrorPercent = (objectSize: number, windowSize: number, errorPercent: number) => {
      const lowerBound = windowSize * (1 - errorPercent / 100);
      const upperBound = windowSize * (1 + errorPercent / 100);
      return objectSize <= upperBound || objectSize >= lowerBound;
    };
    
    const backgroundObject = allObjects?.find(obj => {
      const objectSize = obj.getScaledWidth() * obj.getScaledHeight();
      return isWithinErrorPercent(objectSize, windowSize, errorPercent);
    });
    
    if (backgroundObject) {
      body?.setAttribute('style', `background: ${backgroundObject.fill}; overflow: hidden`)
    } else {
      body?.setAttribute('style', 'background: unset; overflow: hidden')
    }
  }, [manager]);
  
  return { onLoaded }
}

export default useOnLoadedTV
